import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "When should I book a postpartum doula?",
    a: "Most families reach out during the second or third trimester to secure availability — but it's never too late. We frequently support families who reach out after baby arrives, and we shape care around your immediate needs.",
  },
  {
    q: "What areas do you serve?",
    a: "We service the Greater Brisbane area. Reach out via the booking form with your suburb and we'll confirm availability — happy to travel a little for the right fit.",
  },
  {
    q: "Are you certified and insured?",
    a: "Yes. Monica is a DONA-trained postpartum doula, holds a current Queensland Blue Card (Working with Children Check) and CPR/first aid certification, and is fully insured.",
  },
  {
    q: "Do you support all feeding choices?",
    a: "Absolutely. We support breastfeeding, pumping, formula and combination feeding — without judgment. Our role is to help you find what works for your body, baby and life.",
  },
  {
    q: "What does a typical visit look like?",
    a: "Daytime visits flow with your needs — feeding support, baby holding so you can shower or nap, light tidying, a warm meal, an emotional check-in. We follow your lead.",
  },
  {
    q: "How is pricing structured?",
    a: "We offer hourly rates and discounted multi-visit packages. The free consultation is the best way to discuss your needs and receive a tailored quote.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32"
      style={{ background: "var(--bg-tertiary)" }}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-left">
          <span className="section-eyebrow">FAQ</span>
          <span className="gold-divider ml-3 mb-2 align-middle" />
          <h2
            className="font-serif-display mt-4 text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
            style={{ color: "var(--text-main)" }}
            data-testid="faq-headline"
          >
            Tender questions, <em className="not-italic" style={{ color: "var(--blush)" }}>warmly answered.</em>
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl px-6"
              style={{ background: "var(--bg-tertiary)", border: "1px solid var(--border-soft)" }}
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="text-left font-serif-display text-xl md:text-2xl py-5 hover:no-underline"
                style={{ color: "var(--text-main)" }}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                className="pb-6 leading-relaxed text-base"
                style={{ color: "var(--text-muted)" }}
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
